import config from '../config/configureEnv';
import { ajax, getUserAuthDataFromLocalStorage } from '../utils';

export default {
  getInvitations: () => {
    const userAuthData = getUserAuthDataFromLocalStorage();
    const { accessToken, userId } = userAuthData;

    return ajax('GET', `${config.bocaAPIUrl}/users/${userId}/invitations`, {
      urlParams: { access_token: accessToken },
    });
  },

  getAssignableRoles: () => {
    const userAuthData = getUserAuthDataFromLocalStorage();
    const { accessToken } = userAuthData;

    return ajax('GET', `${config.bocaAPIUrl}/users/assignableRoles`, {
      urlParams: { access_token: accessToken },
    });
  },

  sendInvitation: (invitationData) => {
    const userAuthData = getUserAuthDataFromLocalStorage();
    const { accessToken, userId } = userAuthData;

    return ajax('POST', `${config.bocaAPIUrl}/users/${userId}/invitations`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify(invitationData),
    });
  },

  resendInvitation: (invitationId) => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('POST', `${config.bocaAPIUrl}/invitations/${invitationId}/resend`, {
      urlParams: { access_token: accessToken },
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/InvitationAPIConnectors.js